import { apiClient } from "./apiClient";

// Master lists are paginated too. Fetch every page so a valid part or machine
// cannot disappear from a selector merely because its record is on page two.
export const listAllMasterRows = async (endpoint, params = {}) => {
  const rows = [];
  let page = 1;
  while (true) {
    const { data: response } = await apiClient.get(endpoint, {
      params: { ...params, page, limit: 200 },
    });
    if (response?.status === "failed" && !(Array.isArray(response.data) && response.data.length === 0 && response.meta_data?.total_records === 0)) {
      throw new Error(response.message || "Unable to load master records.");
    }
    const current = Array.isArray(response) ? response : response?.data || [];
    if (!Array.isArray(current)) throw new Error("Unable to read master records.");
    rows.push(...current);
    const total = response?.meta_data?.total_records ?? response?.meta?.total ?? response?.total;
    if (!current.length || (total != null ? rows.length >= Number(total) : current.length < 200)) break;
    page += 1;
  }
  return rows;
};

export const batchMasterApi = {
  items: (plantId) => listAllMasterRows("item/", { plant_id: plantId }),
  materials: (plantId) => listAllMasterRows("raw-material/", { plant_id: plantId }),
  inputBatches: (plantId, rawMaterialId) => listAllMasterRows("inputreadybatch/", { plant_id: plantId, raw_material_id: rawMaterialId }),
  lines: (plantId) => listAllMasterRows("line/", { plant_id: plantId }),
  machines: (plantId) => listAllMasterRows("machine/", { plant_id: plantId }),
  shifts: (plantId) => listAllMasterRows("shift/", { plant_id: plantId }),
  oems: () => listAllMasterRows("oem/"),
};
